import * as Sentry from '@sentry/react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Toaster } from 'sonner';
import { theme } from './styles/theme';
import { queryClient } from './lib/queryClient';
import { AuthProviderV2 } from './contexts/AuthContextV2';
import { LanguageProvider } from './i18n';
import AuthGuard from './components/auth/AuthGuard';
import './styles/fonts.css';

function AppContent() {
  // API auth is configured in AuthContextV2 with proper token expiration checking
  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthGuard />
      </ThemeProvider>
      <Toaster position="top-right" richColors duration={5000} />
    </>
  );
}

function App() {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <h2>Something went wrong</h2>
          <p>{(error as Error)?.message}</p>
          <button onClick={resetError}>Try again</button>
        </div>
      )}
    >
      <QueryClientProvider client={queryClient}>
        <LanguageProvider>
          <AuthProviderV2>
            <AppContent />
          </AuthProviderV2>
        </LanguageProvider>
        {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  );
}

export default App;
